module.exports = __webpack_public_path__ + "static/media/Telus_One_page-12.89439287.png";